import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import initActions from './initActions';
import { ModalType } from './types';
import { pushModal } from './basicActions';
import { verifyLoggedOutAccess } from '../../redux/loggedout/actionCreators';
import { ReferralType } from '@wix/da-bi/pkg/constants';
export { pushModal, popModal, replaceModal, removeModal, removeModalsOfType } from './basicActions';
export const initModal = (type, options)=>{
    // return init modal action if available
    const initModalAction = initActions[type];
    return initModalAction && initModalAction(options.params);
};
export const pushBadgeModal = verifyLoggedOutAccess(ReferralType.GIVE, (username, onBadgeSent, onClose)=>pushModal(ModalType.GIVE_BADGE, {
        params: {
            username,
            onBadgeSent,
            onClose
        }
    }));
export const pushPointsModal = verifyLoggedOutAccess(ReferralType.GIVE, (username, title)=>pushModal(ModalType.GIVE_POINTS, {
        params: {
            username,
            title
        }
    }));
export const pushCommentsModal = (typeId, itemId, commentId, parentComment)=>pushModal(ModalType.COMMENT_THREAD, {
        params: {
            commentId,
            typeId,
            itemId,
            parentComment
        }
    });
export const pushConfirmationModal = (params)=>pushModal(ModalType.CONFIRMATION, {
        params
    });
export const pushGlobalConfirmationModal = (params)=>pushModal(ModalType.GLOBAL_CONFIRMATION, {
        params,
        wrapInModal: false
    });
export const pushGlobalConfirmationModalForMM = (params)=>pushModal(ModalType.GLOBAL_CONFIRMATION_FOR_MM, {
        params,
        wrapInModal: false
    });
export const confirmValue = createAction(`${actionPrefix}.CONFIRM_VALUE`, (payload)=>payload);
export const confirmYes = createAction(`${actionPrefix}.CONFIRM_YES`, ()=>({}));
export const confirmNo = createAction(`${actionPrefix}.CONFIRM_NO`, ()=>({}));
export const doNotShowAgainChanged = createAction(`${actionPrefix}.DO_NOT_SHOW_CHANGED`, (key, value)=>({
        key,
        value
    }));
export const showMobileDeviationSharePopup = (deviation)=>pushModal(ModalType.MOBILE_DEVIATION_SHARE, {
        params: {
            deviation
        }
    });
export const showShareLinkPopup = (url, title)=>pushModal(ModalType.SHARE_LINK, {
        params: {
            url,
            title
        }
    });
export const showMobileSharePopup = (url, title)=>pushModal(ModalType.MOBILE_SHARE, {
        params: {
            url,
            title
        }
    });
export const showCookieSettingsPopup = ()=>pushModal(ModalType.COOKIE_SETTINGS, {});
export const showDealerPopup = (content)=>pushModal(ModalType.DEALER, {
        params: {
            content
        }
    });
export const showSubmitModal = verifyLoggedOutAccess(ReferralType.SUBMIT, (type, options)=>pushModal(type, _object_spread({
        wrapInModal: false
    }, options || {})));
export const showFavouritedByModal = (deviation)=>pushModal(ModalType.FAVOURITED_BY, {
        wrapInModal: false,
        params: {
            deviationId: deviation.deviationId,
            typeId: deviation.typeId
        }
    });
export const showDeviantsListModal = (selectedUserId, onItemClick)=>pushModal(ModalType.DEVIANTS_LIST, {
        wrapInModal: false,
        params: {
            selectedUserId,
            onItemClick
        }
    });
export const pushNftLinkPopup = (deviation)=>pushModal(ModalType.NFT_LINK, {
        params: {
            deviation
        }
    });
export const pushNftEditPopup = (deviation, nft)=>pushModal(ModalType.NFT_LINK, {
        params: {
            deviation,
            nft
        }
    });
export const showDiscordConnectSuccessModal = (guildId)=>pushModal(ModalType.DISCORD_CONNECT_SUCCESS, {
        params: {
            guildId
        }
    });
export const showDiscordDisconnectModal = ()=>pushModal(ModalType.DISCORD_DISCONNECT, {});
export const showBadgeInfoModal = (username, badgeId)=>pushModal(ModalType.BADGE_INFO, {
        params: {
            username,
            badgeId
        },
        wrapInModal: false
    });
export const pushAddToGroupModal = (deviation, biData)=>pushModal(ModalType.ADD_TO_GROUP, {
        params: {
            deviation,
            biData
        },
        wrapInModal: false
    });
export const pushAdoptsBuyerModal = (deviation, initialScreen)=>pushModal(ModalType.ADOPT_BUYER_MODAL, {
        wrapInModal: false,
        params: {
            deviation,
            initialScreen
        }
    });
export const pushAdoptsSellerModal = (deviation, initialScreen)=>pushModal(ModalType.ADOPT_SELLER_MODAL, {
        wrapInModal: false,
        params: {
            deviation,
            initialScreen
        }
    });
export const pushUserSettingsModal = ()=>pushModal(ModalType.CONTENT_FILTER_SETTINGS, {
        params: {}
    });
